<template>
  <el-dialog
    :title="$t('delete-account.delete-account-dialog.title')"
    :visible="true"
    width-size="medium"
    height-size="fixed-auto"
    hide-footer-when-empty
    append-to-body
    @close="hideDialog"
  >
    <info-step
      v-if="step === 1"
      :message="message"
    />
    <subscriptions-check-step
      v-if="step === 2"
      @checkbox-change="handleCheckboxChange($event, 'dataAcknowledgementChecked')"
    />
    <select-reason-step
      v-if="step === 3"
      ref="selectReasonForm"
      @form-status-change="handleFormStatusChange"
    />
    <request-confirmation-step
      v-if="step === 4"
      @done-click="hideDialog"
    />
    <template
      v-if="step !== 4"
      #footer-aside
    >
      <div>
        {{ steps }}
      </div>
    </template>
    <template
      v-if="step !== 4"
      #footer
    >
      <el-button
        type="secondary"
        @click="hideDialog"
      >
        {{ $t('action.cancel') }}
      </el-button>
      <el-button
        v-if="step !== 3"
        :disabled="isNextButtonDisabled"
        @click="handleNextButtonClick"
      >
        {{ $t('action.next') }}
      </el-button>
      <el-button
        v-if="step === 3"
        type="danger"
        :disabled="!selectReasonFormValid"
        @click="handleConfirmClick"
      >
        {{ $t('action.confirm') }}
      </el-button>
    </template>
  </el-dialog>
</template>

<script>
import { mapActions } from 'vuex';
import SelectReasonStep from './SelectReasonStep.vue';
import SubscriptionsCheckStep from './SubscriptionsCheckStep.vue';
import RequestConfirmationStep from './RequestConfirmationStep.vue';
import InfoStep from './InfoStep.vue';

export default {
  name: 'DeleteAccountDialog',
  components: { InfoStep, SelectReasonStep, SubscriptionsCheckStep, RequestConfirmationStep },
  props: {
    type: {
      type: String,
      default: 'company'
    }
  },
  emits: [
    'hide'
  ],
  data() {
    return {
        step: 1,
        dataAcknowledgementChecked: false,
        selectReasonFormValid: false
    };
  },
  computed: {
    steps() {
        return this.$t('delete-account.delete-account-dialog.steps', { step: this.step });
    },
    message() {
      return this.type === 'company' ? this.$t('profile.delete-account-dialog.message') : this.$t('consumer-profile.delete-account-dialog.message');
    },
    isNextButtonDisabled() {
      return this.step === 2 && !this.dataAcknowledgementChecked;
    }
  },
  methods: {
    ...mapActions('app', ['requestAccountDeletion']),
    async handleNextButtonClick() {
        this.step++;
    },
    handleCheckboxChange(checked, checkboxName) {
      this[checkboxName] = checked;
    },
    handleFormStatusChange(change) {
      this.selectReasonFormValid = change;
    },
    hideDialog() {
      this.$emit('hide');
    },
    handleConfirmClick() {
      this.requestAccountDeletion(this.$refs.selectReasonForm.formValue);
      this.step++;
    }
  }
};
</script>
